(() => {
  const EASE_MS = 1200;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateCount(el, to, duration) {
    const target = Number(to) || 0;
    if (prefersReducedMotion()) {
      el.textContent = String(target);
      return;
    }

    const start = performance.now();
    const from = 0;

    function frame(now) {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(from + (target - from) * eased));
      if (t < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function activate(root) {
    if (root.dataset.metricsAnimated === 'true') return;
    root.dataset.metricsAnimated = 'true';
    root.classList.add('is-inview');

    root.querySelectorAll('[data-count-to]').forEach((el) => {
      animateCount(el, el.getAttribute('data-count-to'), EASE_MS);
    });

    root.querySelectorAll('[data-gauge-arc]').forEach((arc) => {
      const target = Number(arc.getAttribute('data-gauge-target')) || 78;
      const offset = 100 - Math.max(0, Math.min(100, target));
      // Force paint then animate
      requestAnimationFrame(() => {
        arc.style.strokeDashoffset = String(offset);
      });
    });
  }

  function setup(root) {
    if (!root || root.dataset.metricsReady === 'true') return;
    root.dataset.metricsReady = 'true';

    if (prefersReducedMotion()) {
      activate(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activate(root);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(root);
  }

  function init(scope) {
    const roots = (scope || document).querySelectorAll('[data-bioluma-metrics]');
    roots.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector?.('[data-bioluma-metrics]') ||
      event.target.closest?.('[data-bioluma-metrics]');
    if (root) {
      root.dataset.metricsReady = '';
      root.dataset.metricsAnimated = '';
      root.classList.remove('is-inview');
      root.querySelectorAll('[data-gauge-arc]').forEach((arc) => {
        arc.style.strokeDashoffset = '100';
      });
      setup(root);
    } else {
      init(event.target);
    }
  });
})();
